// extracted by mini-css-extract-plugin
export default {"error":"A5w6H8i8zNra5B_qzG6j","textarea":"V6qOYFtI457y9zOt1pRb"};